'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxForm = require('redux-form');

var _Banners = require('features/Banners/Banners.reducer');

var _Products = require('features/Products/Products.reducer');

var _SearchBox = require('features/Search/SearchBox/SearchBox.reducer');

var _SearchMap = require('features/Search/Map/SearchMap.reducer');

var _Search = require('features/Search/Search.reducer');

var _PaymentMethodSelector = require('components/PaymentMethodSelector/PaymentMethodSelector.reducer');

var _DynamicTags = require('components/DynamicTags/DynamicTags.reducer');

var _LocationInput = require('components/LocationInput/LocationInput.reducer');

var _Vendor = require('vendors/Vendor.reducer');

var _entityReducer = require('../saga/entity-reducer');

var _entityReducer2 = _interopRequireDefault(_entityReducer);

var _careers = require('./features/careers');

var _careers2 = _interopRequireDefault(_careers);

var _homepage = require('./features/homepage');

var _homepage2 = _interopRequireDefault(_homepage);

var _explore = require('./features/explore');

var _explore2 = _interopRequireDefault(_explore);

var _movement = require('./features/movement');

var _movement2 = _interopRequireDefault(_movement);

var _phoneVerification = require('./features/phone-verification');

var _phoneVerification2 = _interopRequireDefault(_phoneVerification);

var _venueFilters = require('./features/venue-filters');

var _venueFilters2 = _interopRequireDefault(_venueFilters);

var _venueDetail = require('./features/venue-detail');

var _venueDetail2 = _interopRequireDefault(_venueDetail);

var _checkout = require('./features/checkout');

var _checkout2 = _interopRequireDefault(_checkout);

var _filtersets = require('./filtersets');

var _filtersets2 = _interopRequireDefault(_filtersets);

var _page = require('./page');

var _page2 = _interopRequireDefault(_page);

var _locale = require('./locale');

var _locale2 = _interopRequireDefault(_locale);

var _modals = require('./modals');

var _modals2 = _interopRequireDefault(_modals);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _cart = require('./cart');

var _cart2 = _interopRequireDefault(_cart);

var _device = require('./device');

var _device2 = _interopRequireDefault(_device);

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _error = require('./error');

var _error2 = _interopRequireDefault(_error);

var _rating = require('./rating');

var _rating2 = _interopRequireDefault(_rating);

var _video = require('./video');

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  form: _reduxForm.reducer,
  filterSets: _filtersets2.default,

  features: (0, _redux.combineReducers)({
    careers: _careers2.default,
    checkout: _checkout2.default,
    dynamicTags: _DynamicTags.reducer,
    explore: _explore2.default,
    homepage: _homepage2.default,
    locationInput: _LocationInput.reducer,
    movement: _movement2.default,
    paymentMethods: _PaymentMethodSelector.reducer,
    phoneVerification: _phoneVerification2.default,
    products: _Products.reducer,
    venueDetail: _venueDetail2.default,
    search: _Search.reducer,
    searchBox: _SearchBox.reducer,
    searchMap: _SearchMap.reducer,
    venueFilters: _venueFilters2.default
  }),

  entities: _entityReducer2.default,

  // Core reducers
  banners: _Banners.reducer,
  cart: _cart2.default,
  device: _device2.default,
  error: _error2.default,
  locale: _locale2.default,
  modals: _modals2.default,
  page: _page2.default,
  request: _request2.default,
  vendor: _Vendor.reducer,

  // Unsorted
  rating: _rating2.default,
  user: _user2.default,
  video: _video2.default
});